import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { NavigationEnd, Router } from '@angular/router';
import { ModalService } from '@avla/ui-design';
import { Modal } from '@avla/ui-design/modal/modal.interface';
import { TokenService } from '@services';
import { UsersService } from '@services/private/users.service';
import { Driver, driver } from 'driver.js';
import { filter } from 'rxjs';
import tour from 'src/assets/json/tour.js'

interface Tourinterface {
  url: string;
  show: boolean;
  driver: object;
  title?: string;
  descriptions?: string;
}

@Component({
  selector: 'app-modal-tour',
  templateUrl: './modal-tour.component.html',
  styleUrls: ['./modal-tour.component.scss'],
})
export class ModalTourComponent implements OnInit {
  public static modalName: string = 'modalTour';
  private driverList: Tourinterface[] = [];
  public currentDriver: Tourinterface;
  private driverObject: Driver;
  private url: string[] = [
    '/policy/create/una-a-una/',
    '/policy/create/payment-schedule/',
    '/project/general/',
    '/project/costs-and-financing/',
    '/project/client/',
    '/project/detail/',
    '/project/documentation/',
    '/project/result/',
    '/policy/policies',
    '/project/mis-proyectos'
  ];
  public formSwitch: UntypedFormGroup = this.formBuilder.group({
    switch: [false, []]
  });
  private isCalling: boolean = false;
  constructor(
    private modalService: ModalService,
    private readonly router: Router,
    private readonly usersService: UsersService,
    private tokenService: TokenService,
    private readonly formBuilder: UntypedFormBuilder,
  ) {}
  ngOnInit(): void {
    this.createDriver();
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        const urlFind = this.url.find((u) => event.url.startsWith(u));
        const urlFinal = urlFind || event.url;
        this.currentDriver = this.driverList.find((d) => d.url == urlFinal);
        if (this.help && this.currentDriver?.show) {
          this.changeStep(urlFinal, true);
        }
      });
      this.modalService.changeModal.subscribe((modal: Modal) => {
        if (
          modal &&
          modal.name === ModalTourComponent.modalName &&
          modal.isOpen &&
          !this.isCalling
        ) {
          this.isCalling = true;
          this.formSwitch.get('switch').setValue(!!TokenService?.user?.help);
          this.isCalling = false;
        }
      });
  }
  play(url: string, step = 0) {
    this.closeModal();
    this.currentDriver = this.driverList.find((d) => d.url == url);
    this.changeStep(url, false, step);
  }

  get getModalName() {
    return ModalTourComponent.modalName;
  }

  closeModal() {
    this.modalService.close(ModalTourComponent.modalName);
  }

  changeStep(url: string, isOnInit = false, step = 0) {
    setTimeout(
      () => {
        if (this.currentDriver) {
          this.currentDriver.show = false;
          this.driverObject = driver(this.currentDriver.driver);
          this.driverObject?.drive(step);
        } else {
          this.currentDriver = {
            show: false,
            driver: { step: [] },
            url,
            title: '',
            descriptions: '',
          };
        }
      },
      isOnInit ? 4000 : 0
    );
  }
  createDriver() {
    this.driverList = tour;
  }

  async onChangeSwitch(): Promise<void> {
    try {
      await this.usersService.updateUserHelp(this.formSwitch.get('switch').value);
      this.tokenService.setHelp(this.formSwitch.get('switch').value);
    } catch (error) {
      this.formSwitch.get('switch').setValue(!!TokenService?.user?.help);
    }
  }
  get help(): boolean {
    return (
      !!TokenService?.user?.help || this.formSwitch.get('switch').value
    );
  }

  get getTextSwitchClassInactive() {
    return {
      'text-gray-5': true,
    };
  }
  get getTextSwitchClassActive() {
    return {
      'text-gray-2': true,
      'font-bold': true,
    };
  }
}
